import { IDocumentGroup } from '../../types/documentGroupList';
import { IDocumentLibraryGroupSchema } from '../../repositories/journal/entities/journal/DocumentLibraryGroupSchema';

/** Мапит структуру группы документов */
export const mapDocumentGroup = ({ groupName: name, data: items }: IDocumentLibraryGroupSchema): IDocumentGroup => ({
  name,
  items,
});
